import * as React from "react";
import { getHashArray, scrollToElement } from "../helpers/helper/index.mjs";
const HashTrigger = (props) => {
  const { renderWrapper = true, scrollOnMatch = true, onMatch, id, children } = props;
  const isInitial = React.useRef(true);
  React.useEffect(() => {
    const handleHashChange = (event) => {
      const hashes = getHashArray();
      if (hashes && hashes.indexOf(id) !== -1) {
        const cb = () => {
          var _a;
          if (!((_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.fromAutoscroll) && scrollOnMatch) {
            scrollToElement(id, void 0, void 0, true);
          }
        };
        if (onMatch) {
          onMatch(id, true, cb);
        } else {
          cb();
        }
      }
    };
    if (isInitial.current) {
      isInitial.current = false;
      handleHashChange();
    }
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [id, onMatch, scrollOnMatch, isInitial]);
  return renderWrapper ? /* @__PURE__ */ React.createElement("div", { id }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export {
  HashTrigger
};
